module.exports = __webpack_public_path__ + "static/img/li_ru_gang_list.9ea734d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dashboard/li_ru_gang_list.png
// module id = sLDT
// module chunks = 2